import { BookmarkElement } from "../../models/bookmark-element.model";
import { BookmarkElementsOperator } from "./bookmark-elements.operator";
import { Bookmark } from "../../models/bookmark.model";
import { DxDataGridComponent } from "devextreme-angular";
import { isFunction } from "src/app/helpers/type-utils";

/**
 * 
 */
export class DxDataGridBookmarkElementsOperator extends BookmarkElementsOperator {

	public override applyBookmarkElements(bookmarkElements: BookmarkElement[]): void {
		const dxDataGridComponent: DxDataGridComponent = isFunction(this.dxDataGridComponent) ? this.dxDataGridComponent() : this.dxDataGridComponent;

		// Use `beginUpdate` and `endUpdate` in order to prevent redraw.
		dxDataGridComponent.instance.beginUpdate();

		const gridStateBookmarkElement: BookmarkElement = bookmarkElements.find((element) => element.key === 'grid-state');

		if (gridStateBookmarkElement) {
			dxDataGridComponent.instance.state(JSON.parse(gridStateBookmarkElement.value));
		}

		dxDataGridComponent.instance.endUpdate();
	}

	public override prepareBookmarkElements(bookmark: Bookmark): BookmarkElement[] {
		const dxDataGridComponent: DxDataGridComponent = isFunction(this.dxDataGridComponent) ? this.dxDataGridComponent() : this.dxDataGridComponent;

		const elements: BookmarkElement[] = [
			new BookmarkElement(
				undefined,
				bookmark.bookmarkId,
				'grid-state',
				JSON.stringify(dxDataGridComponent.instance.state()),
				this.id
			),
		];

		return elements;
	}

	public static readonly DEFAULT_ID_PART: number = 3;

	/**
	 * 
	 * @param id Responsible for identifying multiple `BookmarkElement`s that this operator controls.
	 */
	constructor(
		id: string,
		public dxDataGridComponent: DxDataGridComponent | (() => DxDataGridComponent),
	) {
		super(id);
	}
}
